<template>
  <div class="container is-fluid">
    <div class="columns">
      <instructors-list
        :instructors="instructors"
        @instructorSelected="instructorSelected"
        @reloadInstructors="fetchInstructors"
      ></instructors-list>
      <instructor
        :instructor="selectedInstructor"
        v-if="selectedInstructor"
        @reloadInstructors="fetchInstructors"
      ></instructor>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";
import InstructorsList from "@/components/AdminInstructors/InstructorsList.vue";
import Instructor from "@/components/AdminInstructors/Instructor.vue";

export default {
  name: "Instructors",
  components: {
    InstructorsList,
    Instructor,
  },
  data: function () {
    return {
      instructors: [],
      selectedInstructor: null,
    };
  },
  created: function () {
    this.fetchInstructors();
  },
  methods: {
    fetchInstructors() {
      axios.get("/api/instructors/").then((response) => {
        this.instructors = response.data;
        if (
          !this.instructors.find(
            (instructor) =>
              (this.selectedInstructor ? this.selectedInstructor._id : 0) ==
              instructor.id
          )
        ) {
          this.selectedInstructor = null;
        }
      });
    },
    instructorSelected(instructor) {
      this.selectedInstructor = instructor;
    },
  },
};
</script>

<style scoped>
.panel-block {
  text-align: left;
}
.container {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.columns {
  margin-top: 0 !important;
  height: 100%;
  overflow: hidden;
}
</style>